import { useResizeObserver } from '@ardoq/hooks';
import { Box } from '@ardoq/layout';
import { WithPopover } from '@ardoq/popovers';
import { useLayoutEffect, useRef, useState } from 'react';
import { breadcrumbsLayout } from './breadcrumbsLayout';
import { BreadcrumbTrail } from './BreadcrumbTrail';
import { defaultProps } from './consts';
import { BreadcrumbsLayout, BreadcrumbsProps } from './types';

export const Breadcrumbs = (props: BreadcrumbsProps) => {
  const [layout, setLayout] = useState<BreadcrumbsLayout>({ breadcrumbs: [] });
  const ref = useRef<HTMLDivElement>(null);
  const {
    breadcrumbs,
    textStyles = defaultProps.textStyles,
    leadingIcon = defaultProps.leadingIcon,
  } = props;
  const { width = 0 } = useResizeObserver(ref);
  useLayoutEffect(() => {
    const layout = breadcrumbsLayout(
      {
        ...defaultProps,
        leadingIcon,
        breadcrumbs,
        textStyles,
      },
      width
    );
    setLayout(layout);
  }, [breadcrumbs, textStyles, leadingIcon, width]);

  return (
    <div ref={ref} style={{ width: '100%', minWidth: 0 }}>
      <WithPopover
        content={
          layout.popoverContent
            ? () => (
                <BreadcrumbTrail
                  breadcrumbs={layout.popoverContent!}
                  textStyles={textStyles}
                />
              )
            : undefined
        }
      >
        <Box>
          <BreadcrumbTrail
            breadcrumbs={layout.breadcrumbs}
            textStyles={textStyles}
          />
        </Box>
      </WithPopover>
    </div>
  );
};
